"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _types = require("./types");
var _styles = require("./styles");
var _excluded = ["variant", "size", "type", "offHover", "children", "buttonRef"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ButtonTs = function ButtonTs(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _types.Sizes.NORMAL : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$offHover = _ref.offHover,
    offHover = _ref$offHover === void 0 ? false : _ref$offHover,
    children = _ref.children,
    buttonRef = _ref.buttonRef,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ButtonVariant = ButtonsDict[variant];
  return /*#__PURE__*/_react["default"].createElement(ButtonVariant, (0, _extends2["default"])({
    $size: size,
    $offHover: offHover,
    type: type
  }, props, {
    ref: buttonRef
  }), children);
};
var BasePropsStyle = _styledComponents["default"].button.withConfig({
  displayName: "ButtonTs__BasePropsStyle",
  componentId: "sc-7xgfma-0"
})(["&{cursor:pointer;font-family:inherit;", "}"], function (props) {
  return props.disabled && (0, _styledComponents.css)(["cursor:default;user-select:none;"]);
});
var BaseStyle = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "ButtonTs__BaseStyle",
  componentId: "sc-7xgfma-1"
})(["&:focus{outline:none;}border-radius:4px;padding:0 10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", ""], function (_ref2) {
  var $size = _ref2.$size;
  return _styles.stylesOfSizes[$size];
});
var StyledButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "ButtonTs__StyledButton",
  componentId: "sc-7xgfma-2"
})(["--background-color:var(--background);border:0;background-color:var(--background-color);border-radius:var(--border-radius);color:var(--black);", " ", ""], function (_ref3) {
  var disabled = _ref3.disabled,
    $offHover = _ref3.$offHover;
  return !(disabled || $offHover) && (0, _styledComponents.css)([":hover{background:linear-gradient( 0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100% ),var(--background-color);}"]);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]);
});
var StyledPrimaryButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "ButtonTs__StyledPrimaryButton",
  componentId: "sc-7xgfma-3"
})(["", ";font-weight:500;", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.elements.button.primary;
}, function (_ref6) {
  var $offHover = _ref6.$offHover;
  return $offHover && (0, _styledComponents.css)(["&,&:hover{box-shadow:var(--box-shadow);}"]);
});
var StyledFunctionalButton = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "ButtonTs__StyledFunctionalButton",
  componentId: "sc-7xgfma-4"
})(["appearance:none;background-color:transparent;border:none;color:inherit;font:inherit;"]);
var StyledErrorButton = (0, _styledComponents["default"])(StyledButton).withConfig({
  displayName: "ButtonTs__StyledErrorButton",
  componentId: "sc-7xgfma-5"
})(["border-color:#d0021b;color:#d0021b;:hover{border-color:#d0021b;color:#d0021b;}"]);
var ButtonsDict = {
  functional: StyledFunctionalButton,
  primary: StyledPrimaryButton,
  "default": StyledButton,
  error: StyledErrorButton
};
var _default = exports["default"] = ButtonTs;